import type { ReactElement } from 'react';
import { useTranslation } from 'react-i18next';

import { StatusReasonDialog } from './StatusReasonDialog';

/**
 * Suspend-user confirmation dialog (AUT-124). Collects a required reason
 * and resolves it to the parent, which routes the PATCH through the TOTP
 * step-up. Destructive variant (red confirm).
 */
export interface SuspendUserDialogProps {
  open: boolean;
  loading?: boolean;
  onConfirm: (reason: string) => void;
  onCancel: () => void;
}

export const SuspendUserDialog = ({
  open,
  loading,
  onConfirm,
  onCancel,
}: SuspendUserDialogProps): ReactElement => {
  const { t } = useTranslation();
  return (
    <StatusReasonDialog
      open={open}
      title={t('users.suspendDialog.title')}
      description={t('users.suspendDialog.description')}
      reasonLabel={t('users.suspendDialog.reasonLabel')}
      reasonRequiredKey="users.suspendDialog.reasonRequired"
      reasonMaxKey="users.suspendDialog.reasonMax"
      confirmLabel={t('users.suspendDialog.confirm')}
      color="error"
      {...(loading !== undefined ? { loading } : {})}
      onConfirm={onConfirm}
      onCancel={onCancel}
    />
  );
};
